module.exports = __webpack_public_path__ + "img/spinner.c9d71d8d.gif";